import { INVOICES_CREATE } from '../../constants/CopilotInAppActionTypes';
export const invoicesCreate = __action => ({
  data: {
    intent: INVOICES_CREATE
  }
});